export const staffFields = [
    {
        section: "Basic Information",
        fields: [
            { name: "firstName", label: "First Name", required: true, type: "text" },
            { name: "middleName", label: "Middle Name", type: "text" },
            { name: "lastName", label: "Last Name", required: true, type: "text" },
            { name: "gender", label: "Gender", required: true, type: "select", options: ["MALE", "FEMALE", "OTHER"] },
            { name: "dob", label: "Date of Birth", required: true, type: "date" },
            { name: "placeOfBirth", label: "Place of Birth", type: "text" },
            { name: "bloodGroup", label: "Blood Group", type: "select", options: ["A_POSITIVE", "A_NEGATIVE", "B_POSITIVE", "B_NEGATIVE", "O_POSITIVE", "O_NEGATIVE", "AB_POSITIVE", "AB_NEGATIVE"] },
            { name: "nationality", label: "Nationality", type: "text" },
            { name: "religion", label: "Religion", type: "text" },
            { name: "category", label: "Category", type: "text" },
            { name: "email", label: "Email", required: true, type: "email" },
            { name: "phoneNumber", label: "Phone Number", required: true, type: "text", maxLength: 10 },
            { name: "lastFourDigitsOfAadhaarNumber", label: "Last Four Digits of Aadhaar", type: "text", maxLength: 4 },
        ]
    },
    {
        section: "Contact Information",
        fields: [
            { name: "currentAddress", label: "Address Line 1", type: "text" },
            { name: "currentAddress2", label: "Address Line 2", type: "text" },
            { name: "city", label: "City", required: true, type: "text" },
            { name: "state", label: "State", type: "text" },
            { name: "country", label: "Country", type: "text" },
            { name: "pincode", label: "Pincode", type: "text" },
            { name: "alternatePhoneNumber", label: "Alternate Contact Number", type: "text", maxLength: 10 },
        ]
    },
    {
        section: "Staff Information",
        fields: [
            { name: "employeeId", label: "Employee ID", required: true, type: "text" },
            { name: "designation", label: "Designation", required: true, type: "text" },
            { name: "department", label: "Department", required: true, type: "text" },
            { name: "joiningDate", label: "Joining Date", required: true, type: "date" },
            { name: "staffContractType", label: "Contract Type", required: true, type: "select", options: ["PERMANENT", "TEMPORARY", "CONTRACT"] },
            { name: "responsibilities", label: "Responsibilities", type: "text" },
            { name: "identificationMark", label: "Identification Mark", type: "text" },
            { name: "drivingLicenseNumber", label: "Driving License Number", type: "text" },
            { name: "drivingLicenseValidity", label: "Driving License Validity", type: "date" },
            { name: "drivingExperienceYears", label: "Driving Experience (Years)", type: "number" },
        ]
    }
];
